import { useEffect, useState } from 'react';

import { getPasswordPolicy } from '@mygpt/app/apis';
import type { PasswordRules } from '@mygpt/app/apis';

export interface PasswordPolicyState {
  /** true = 全局策略未配置(或拉取失败兜底),维持现网 legacy 行为 */
  legacy: boolean;
  rules: PasswordRules | null;
  loading: boolean;
}

/**
 * 加载密码策略(GET /auth/password-policy)
 * - 匿名可调:注册/重置页返回全局规则;带 token 时返回该用户生效规则(企业覆盖优先)
 * - 请求失败视为 legacy 模式兜底,不阻塞页面渲染与提交
 */
export const usePasswordPolicy = (): PasswordPolicyState => {
  const [state, setState] = useState<PasswordPolicyState>({ legacy: true, rules: null, loading: true });

  useEffect(() => {
    let active = true;
    getPasswordPolicy()
      .then((res) => {
        if (!active) return;
        const data = res?.data;
        if (data && data.legacy === false && data.rules) {
          setState({ legacy: false, rules: data.rules, loading: false });
        } else {
          setState({ legacy: true, rules: null, loading: false });
        }
      })
      .catch(() => {
        // 拉取失败兜底为 legacy,各页面保持现状行为
        if (active) setState({ legacy: true, rules: null, loading: false });
      });
    return () => {
      active = false;
    };
  }, []);

  return state;
};
